export const iconSize = 65;
export const borderSize = 2;
export const barOffset = 10;
export const barWidth = 20;
export const healthBarLength = 345;
export const spitBarLength = 285;
export const hudDepth = -50;
